import React from 'react';

export const WelcomeTitle = props => (
    <div className="account__head">
        <h3 className="account__title">
            Welcome to
            <span className="account__logo">
                SuperBike
                <span className="account__logo-accent">Factory</span>
            </span>
        </h3>
        {props.children}
    </div>
);



// WEBPACK FOOTER //
// ./src/modules/App/components/WelcomeTitle.js